import {Icon, WarningIcon} from '@taopix/taopix-design-system';
import React from 'react';
import {useTranslation} from 'react-i18next';

export const AssetErrorBadge = ({id}: {id: string}) => {
  const {t} = useTranslation();

  return (
    <>
      <Icon
        icon={<WarningIcon />}
        size={'large'}
        toolTipLabel={t('str_WarningUnableToUploadImage')}
      />
    </>
  );
};
